'use client';

import { getCookie } from 'cookies-next/client';

import { CENTRALIZED_LOGIN_IS_AUTHENTICATED } from '@/constants/cookies';

import { isTokenAuthenticated } from '../isTokenAuthenticated';
import { isOnlyMvpdAuthenticated } from './isOnlyMvpdAuthenticated';

// We want to run this function to determine if we need to do a manual signIn call
// to update FOXKITAUTHN_WEB cookie based on what the auth site holds.
export function isOnlyCentralizedLoginAuthenticated(accessToken: string): boolean {
  const isCentralizedLogin = getCookie(CENTRALIZED_LOGIN_IS_AUTHENTICATED) === 'true';

  let ok = isCentralizedLogin && !isTokenAuthenticated(accessToken);

  if (isCentralizedLogin && isOnlyMvpdAuthenticated()) {
    ok = true;
  }

  return ok;
}
